import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import {Contact} from './contact.model';

@Injectable()
export class ContactService {

    private resourceUrl = 'api/public/contact';

    constructor(private http: Http) { }

    create(contact: Contact): Observable<Response> {
        let copy: Contact = Object.assign({}, contact);
        copy.dateNaissance = new Date(Date.UTC(contact.dateNaissance.getFullYear(),
            contact.dateNaissance.getMonth(), contact.dateNaissance.getDate()));
        return this.http.post(this.resourceUrl, copy).map((res: Response) => {
            return res;
        });
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/contact/contact.service.ts